
/**
 * Tells if val is undefined or is null.
 *
 * @param string 	val
 *
 * @return bool
 */
export default function(val) {
	return val === null || val === '';
};
